import styled from 'styled-components';
import Colors from '@components/shared/Colors';

interface IF {
  $open: boolean;
  $animateIn?: boolean;
  $type?: string;
  $onTop?: boolean;
  $right?: boolean | undefined;
}

interface IC {
  $open: boolean;
  $width?: string;
}

export const FullPageContainer = styled.div<IF>`
  display: flex;
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: ${(props) => (props.$onTop ? '101' : '100')};
  background-color: ${(props) => (props.$animateIn ? `${Colors.navyBlue}25` : 'transparent')};
  display: ${(props) => (props.$open ? 'flex' : 'none')};
  animation: fadein 0.2s ease-in-out;

  @media (max-width: 768px) {
    ${(props) => {
      if (props.$type === 'vms-menu') {
        return `
      left: 5px;
      right: 5px;
      top: 70px;
      bottom: 0;
      width: auto;
      height: auto;
      `;
      }
      return ``;
    }}
  }

  ${(props) => {
    if (props.$right) {
      return `justify-content: flex-end;`;
    }
    return ``;
  }}
`;

export const AnimationContainer = styled.div<IC>`
  transition: ${(props) => (props.$width === '100%' ? 'opacity' : 'width')} 0.2s ease-in-out;

  ${(props) =>
    props.$width === '100%'
      ? `opacity: ${props.$open ? 1 : 0}; width: 100%;`
      : `width: ${props.$open ? `${props.$width ? props.$width : '560px'}` : 0}; opacity: 1;`};

  overflow: hidden;
  overflow-y: auto;
  height: 100%;

  @media only screen and (max-width: 768px) {
    width: 100vw;
    max-width: 100%;
    opacity: ${(props) => (props.$open ? 1 : 0)};
    transition: opacity 0.2s ease-in-out;
  }
`;
